import { registerQuery } from 'data-fetching-client';
import { fetchUserPreferences } from '../api/fetchUserPreferences';
export const USER_PREFERENCES_QUERY = registerQuery({
  fieldName: 'userPreferences',
  args: [],
  fetcher: () => fetchUserPreferences()
});